import React, { useEffect, useState } from "react";
import { getEmployees, getInterns, getLeaders, viewLeaves } from "../../http";
import { useHistory } from "react-router-dom";
import Loading from "../Loading";

const LeaveView = () => {
  const [type, setType] = useState();
  const [status, setStatus] = useState();
  const [appliedDate, setAppliedDate] = useState();
  const [applications, setApplications] = useState();
  const history = useHistory();
  const [employees, setEmployees] = useState();
  const [employeeMap, setEmployeeMap] = useState();
  const [selectedEmployee, setSelectedEmployee] = useState();

  useEffect(() => {
    let empObj = {};
    const fetchData = async () => {
      const res = await viewLeaves({});
      const { data } = res;
      // Filter applications where leaderResponse is either "Approved" or "Pending"
      const filteredApplications = data.filter(
        (app) =>
          app.leaderResponse === "Approved" || app.leaderResponse === "Pending"
      );
      setApplications(filteredApplications);
    };

    const fetchEmployees = async () => {
      const emps = await getEmployees();
      const leaders = await getLeaders();
      const interns = await getInterns();
      emps?.data?.forEach(
        (employee) => (empObj[employee.id] = [employee.name, employee.email])
      );
      leaders?.data?.forEach(
        (leader) => (empObj[leader.id] = [leader.name, leader.email])
      );
      interns?.data?.forEach(
        (intern) => (empObj[intern.id] = [intern.name, intern.email])
      );
      console.log("🔹 Employee Map:", empObj);
      console.log("🔹 Employees:", emps?.data?.length || 0);
      console.log("🔹 Leaders:", leaders?.data?.length || 0);
      console.log("🔹 Interns:", interns?.data?.length || 0);
      setEmployeeMap(empObj);
      setEmployees([...emps?.data, ...leaders?.data, ...interns?.data]);
    };

    fetchData();
    fetchEmployees();
  }, []);

  const searchLeaveApplications = async () => {
    const obj = {};

    if (selectedEmployee) {
      obj["applicantID"] = selectedEmployee;
    }

    if (type) {
      obj["type"] = type;
    }
    if (status) {
      obj["adminResponse"] = status;
    }
    if (appliedDate) {
      obj["appliedDate"] = appliedDate;
    }

    const res = await viewLeaves(obj);
    const { data } = res;

    // Filter applications where leaderResponse is either "Approved" or "Pending"
    const filteredApplications = data.filter(
      (app) =>
        app.leaderResponse === "Approved" || app.leaderResponse === "Pending"
    );

    setApplications(filteredApplications);

    setAppliedDate("");
    setType("");
    setStatus("");
  };

  return (
    <>
      {applications ? (
        <div className="main-content">
          <section className="section">
            <div className="card">
              <div className="card-header d-flex justify-content-between">
                <h4>Leave Applications</h4>
              </div>
            </div>

            <div className="d-flex flex-wrap justify-content align-items-center-center w-100 gap-2">
              <div className="col-md col-12 mb-2">
                <select
                  className="form-control select2 w-100"
                  value={selectedEmployee}
                  onChange={(e) => setSelectedEmployee(e.target.value)}>
                  <option value="">Employees</option>
                  {employees?.map((employee) => (
                    <option key={employee._id} value={employee.id}>
                      {employee.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md col-12 mb-2">
                <select
                  name="type"
                  onChange={(e) => setType(e.target.value)}
                  className="form-control select2 w-100">
                  <option>Select</option>
                  <option>Sick Leave</option>
                  <option>Casual Leave</option>
                  <option>Emergency Leave</option>
                </select>
              </div>
              <div className="col-md col-12 mb-2">
                <select
                  name="type"
                  onChange={(e) => setStatus(e.target.value)}
                  className="form-control select2 w-100">
                  <option>Select</option>
                  <option>Pending</option>
                  <option>Approved</option>
                  <option>Rejected</option>
                </select>
              </div>

              <div className="col-md col-12 mb-2">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <div className="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </div>
                  </div>
                  <input
                    onChange={(e) => setAppliedDate(e.target.value)}
                    type="date"
                    id="startDate"
                    name="startDate"
                    className="form-control"></input>
                </div>
              </div>

              <button
                onClick={searchLeaveApplications}
                className="btn btn-lg btn-primary col-md col-12 mb-2">
                Search
              </button>
            </div>
          </section>
          <div className="table-responsive">
            <table className="table table-striped table-md center-text">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Number of Leaves</th>
                  <th>Type</th>
                  <th>Title</th>
                  <th>Applied Date</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody className="sidebar-wrapper">
                {applications?.map((application, idx) => (
                  <tr
                    className="hover-effect"
                    onClick={() => history.push(`leaves/${application._id}`)}>
                    <td>{idx + 1}</td>
                    <td>
                      {employeeMap && employeeMap[application.applicantID] && employeeMap[application.applicantID][0]}
                    </td>
                    <td>
                      {employeeMap && employeeMap[application.applicantID] && employeeMap[application.applicantID][1]}
                    </td>
                    {/* <td>{application.period}</td> */}
                    <td>
                      {Math.ceil(
                        (new Date(application.endDate) -
                          new Date(application.startDate)) /
                          (1000 * 60 * 60 * 24)
                      ) + 1}
                    </td>

                    <td>{application.type}</td>
                    <td>{application.title}</td>
                    <td>
                      {new Date(application?.appliedDate)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")}
                    </td>
                    <td
                      className={`${
                        application.adminResponse?.toLowerCase() === "rejected"
                          ? "text-danger"
                          : application.adminResponse?.toLowerCase() ===
                            "pending"
                          ? "text-danger"
                          : "text-success"
                      }`}>
                      {application.adminResponse
                        ? application.adminResponse.charAt(0).toUpperCase() +
                          application.adminResponse.slice(1).toLowerCase()
                        : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default LeaveView;
